import Const from '../Const'
class DataTools {
  constructor() {
    this.instance = null
  }
  static createDataToolsClass = ()=> {
    if(!this.instance){
      this.instance = new DataTools()
    }
    return this.instance
  }

  randomCount = (count)=> {
    const myRandom = Math.random() * count
    for (let i = 1; i <= count; i++) {
      if (myRandom <= i) {
        return i - 1
      }
    }
  }

  convertInputToObject = (input)=> {
    let inputArray = input.toLowerCase().trim().split(/\s+/)
    for(let i=0; i< inputArray.length; i++){
      inputArray[i] = inputArray[i].replace(/-/g," ")
    }
    let standardInput = {
      type: "",
      arguments: []
    }
    if (inputArray.length === 0) {
      return standardInput
    }
    else if (inputArray.length === 1) {
      if (Const.openArgument.has(inputArray[0])) {
        standardInput.type = Const.inputKey.open
        standardInput.arguments.push(Const.openArgument.get(inputArray[0]))
      } else if (Const.inputType.has(inputArray[0])) {
        standardInput.type = Const.inputType.get(inputArray[0])
      } else if (inputArray[0] === "") {} else {
        standardInput.type = Const.inputKey.search
        standardInput.arguments.push(inputArray[0])
      }
      return standardInput
    }
    else {
      if (Const.inputType.has(inputArray[0])) {
        standardInput.type = Const.inputType.get(inputArray[0])
        standardInput.arguments = inputArray.slice(1)
        if (standardInput.type === Const.inputKey.open) {
          standardInput.arguments = []
          for (let i = 1; i < inputArray.length; i++) {
            if (Const.openArgument.has(inputArray[i])) {
              standardInput.arguments.push(Const.openArgument.get(inputArray[i]))
              break
            }
          }
          if(standardInput.arguments.length === 0){
            standardInput.type = Const.inputKey.search
            standardInput.arguments = inputArray.slice(1)
            standardInput.lastType = Const.inputKey.open
          }
        }
      } else {
        standardInput.type = Const.inputKey.search
        standardInput.arguments = inputArray.slice(0)
      }
      return standardInput
    }
  }
  addEffectToStandardInput = (standardInput, defaultValue)=> {
    let tempStandardInput = {}
    tempStandardInput.type = standardInput.type
    tempStandardInput.arguments = standardInput.arguments
    if(typeof standardInput.lastType !== 'undefined')
      tempStandardInput.lastType = standardInput.lastType

    switch (standardInput.type) {
      case Const.inputKey.open:
        tempStandardInput.effect = Const.inputKey.open
        break;
      case Const.inputKey.search:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.search)
        break;
      case Const.inputKey.video:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.video)
        break;
      case Const.inputKey.music:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.music)
        break;
      case Const.inputKey.mv:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.mv)
        break;
      case Const.inputKey.play:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.play)
        break;
      case Const.inputKey.wiki:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.wiki)
        break;
      case Const.inputKey.question:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.question)
        break;
      case Const.inputKey.news:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.news)
        break;
      case Const.inputKey.playMv:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.playMv)
        break;
      case Const.inputKey.buy:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.buy)
        break;
      case Const.inputKey.code:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.code)
        break;
      case Const.inputKey.airticket:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.airticket)
        break;
      case Const.inputKey.trainticket:
        tempStandardInput.effect = defaultValue.get(Const.inputKey.trainticket)
        break;
      default:
        tempStandardInput.effect = tempStandardInput.type
        break;
    }

    return tempStandardInput

  }
  convertAsyncDataToEffect = (data)=>{
    let effect = {
      url: ""
      ,errorInfo: data.errorCount
    }
    effect.keys = ""

    if(data.type === Const.inputKey.playQQMusic){
      handleQQMusicEffect(data)
    }
    else if(data.type === Const.inputKey.playQQMusicMv){
      handleQQMusicMvEffect(data)
    }

    return effect

    function handleQQMusicMvEffect(data){
      let songs = data.songs
      console.log(songs)
      let songData = {
        nameList: []
        ,songList: []
      }
      let singerData = {
        nameList: []
        ,songList: []
        ,hotSongList: []
      }
      // 如果有无效字符，剔除
      for(let i=0; i<songs.length; i++){
        if(songs[i].message !== ""){
            songs.splice(i,1)
            effect.errorInfo.push(i)
            i--
        }
      }
      // 如果无有效输入，不执行操作
      if(songs.length === 0){
        return
      }
      // 遍历所有有效数据，把数据按歌手和歌曲分类
      for(let i=0;i<songs.length;i++){
        // 关键字非歌手
        if(typeof songs[i].data.zhida.list === 'undefined'){
          if(typeof songs[i].data.zhida.zhida_singer === 'undefined')
        {
          let songListValue = []
          for(const list of songs[i].data.song.list){
            songListValue.push(
              {
                songName: list.name
                ,songMid: list.mid
                ,singer: list.singer
                ,mvMid: list.mv.vid
              }
            )
          }
          songData.nameList.push(songs[i].data.song.list[0].name)
          songData.songList.push(songListValue)
        }
        // 关键字是歌手
        else{
          let songListValue = []
          let hotSongListValue = []
          for(const list of songs[i].data.song.list){
            songListValue.push(
              {
                songName: list.name
                ,songMid: list.mid
                ,singer: list.singer
                ,mvMid: list.mv.vid
              }
            )
          }
          for(const hotSong of songs[i].data.zhida.zhida_singer.hotsong){
            hotSongListValue.push(
              {
                songMid: hotSong.songMID
                ,songName: hotSong.songName
              }
            )
          }
          singerData.nameList.push(songs[i].data.zhida.zhida_singer.singerName)
          singerData.songList.push(songListValue)
          singerData.hotSongList.push(hotSongListValue)
        }
      }
      else {
        if(songs[i].data.zhida.list.length === 0 ||
          typeof songs[i].data.zhida.list[0].zhida_singer === 'undefined')
        {
          let songListValue = []
          for(const list of songs[i].data.song.list){
            songListValue.push(
              {
                songName: list.name
                ,songMid: list.mid
                ,singer: list.singer
                ,mvMid: list.mv.vid
              }
            )
          }
          songData.nameList.push(songs[i].data.song.list[0].name)
          songData.songList.push(songListValue)
        }
        // 关键字是歌手
        else{
          let songListValue = []
          let hotSongListValue = []
          for(const list of songs[i].data.song.list){
            songListValue.push(
              {
                songName: list.name
                ,songMid: list.mid
                ,singer: list.singer
                ,mvMid: list.mv.vid
              }
            )
          }
          for(const hotSong of songs[i].data.zhida.list[0].zhida_singer.hotsong){
            hotSongListValue.push(
              {
                songMid: hotSong.songMID
                ,songName: hotSong.songName
              }
            )
          }
          singerData.nameList.push(songs[i].data.zhida.list[0].zhida_singer.singerName)
          singerData.songList.push(songListValue)
          singerData.hotSongList.push(hotSongListValue)
        }
      }

      }//把关键字按歌手和歌曲分类的for循环结束
      // 当关键字全为歌手时
      if(songData.nameList.length === 0 && songData.songList.length === 0){
        for(const value of singerData.songList){
          for(const song of value){
            if(song.mvMid !== ""){
              effect.keys = song.mvMid
              break
            }
          }
          if(effect.keys !== ""){
            break
          }
        }
      }
      // 当关键字全为歌曲时
      else if(singerData.nameList.length === 0 && singerData.songList.length === 0){
        for(const value of songData.songList){
          for(const song of value){
            if(song.mvMid !== ""){
              effect.keys = song.mvMid
              break
            }
          }
          if(effect.keys !== ""){
            break
          }
        }
      }
      else{
        //首先把所有歌手作为整体，匹配所有歌曲
        //遍历输入的歌曲关键字
        for(const value of songData.songList)
        {
          // 遍历每个歌曲关键字中的歌曲列表
          for(const song of value){
            // 如果歌手长度和歌曲列表歌手长度不匹配，不进行后续复杂操作
            if(song.singer.length !== singerData.nameList.length)
              continue
            let matching = []
            // 遍历歌曲中的歌手列表
            for(const singer of song.singer){
              // 遍历singerList中的歌手列表
              for(let i=0; i<singerData.nameList.length; i++){
                // 如果匹配，则对位数标记
                if(singer.name === singerData.nameList[i] && !matching[i])
                {
                  matching[i] = true
                }
              }
            }
            // 如果二者能完全匹配，则验证通过
            if(matching.filter((data)=>data === true).length === song.singer.length
          && song.mvMid !== ""){
              effect.keys = song.mvMid
              break
            }
          }
          if(effect.keys !== ""){
            break
          }
        }//歌手作为整体匹配结束
        // 歌手作为分割元素，分别匹配歌曲列表
        // 当songData.songList的length不为0，则说明需要继续匹配
        if(effect.keys === ""){
          for(const value of songData.songList)
          {
            for(const song of value){
              if(effect.keys !== ""){
                break
              }
              for(let i=0; i<singerData.nameList.length; i++)
              {
                if(effect.keys !== ""){
                  break
                }
                for(const singer of song.singer){
                  if(singer.name === singerData.nameList[i]){
                    if(song.mvMid !== ""){
                      effect.keys = song.mvMid
                      break
                    }
                  }
                }
              }
            }
            if(effect.keys !== "")
              break
          }
        }//歌手作为分割元素匹配结束
        // 开始歌曲作为分割元素匹配歌手的歌曲列表
        if(effect.keys === ""){
          for(const name of songData.nameList)
          {
            if(effect.keys !== ""){
              break
            }
            for(const list of singerData.songList)
            {
              if(effect.keys !== ""){
                break
              }
              for(const song of list){
                if(name === song.songName){
                  if(song.mvMid !== ""){
                    effect.keys = song.mvMid
                    break
                  }
                }
              }
            }
          }
        }//固定歌曲匹配歌手的歌曲列表结束
        // 开始剩余歌曲处理
        if(effect.keys === ""){
          for(const value of songData.songList){
            for(const song of value){
              if(song.mvMid !== ""){
                effect.keys = song.mvMid
                break
              }
            }
          }
        }//剩余歌曲处理结束
        //提取keyList的元素
      }
      if(effect.keys !== "")
      effect.url = Const.httpApi.get(Const.inputKey.playQQMusicMv).playFirstHalf+
      effect.keys+Const.httpApi.get(Const.inputKey.playQQMusicMv).playSecondHalf
    }








    //函数内部声明函数，用来处理qq音乐
    function handleQQMusicEffect(data){
      let songs = data.songs
      console.log(songs)
      let songData = {
        nameList: []
        ,songList: []
      }
      let singerData = {
        nameList: []
        ,songList: []
        ,hotSongList: []
      }
      // 如果有无效字符，剔除
      for(let i=0; i<songs.length; i++){
        if(songs[i].message !== ""){
            songs.splice(i,1)
            effect.errorInfo.push(i)
            i--
        }
      }
      // 如果无有效输入，不执行操作
      if(songs.length === 0){
        return
      }
      // 遍历所有有效数据，把数据按歌手和歌曲分类
      for(let i=0;i<songs.length;i++){
        // 关键字非歌手
        if(typeof songs[i].data.zhida.list === 'undefined'){
          if(typeof songs[i].data.zhida.zhida_singer === 'undefined')
        {
          let songListValue = []
          for(const list of songs[i].data.song.list){
            songListValue.push(
              {
                songName: list.name
                ,songMid: list.mid
                ,singer: list.singer
                ,mvMid: list.mv.vid
              }
            )
          }
          songData.nameList.push(songs[i].data.song.list[0].name)
          songData.songList.push(songListValue)
        }
        // 关键字是歌手
        else{
          let songListValue = []
          let hotSongListValue = []
          for(const list of songs[i].data.song.list){
            songListValue.push(
              {
                songName: list.name
                ,songMid: list.mid
                ,singer: list.singer
                ,mvMid: list.mv.vid
              }
            )
          }
          for(const hotSong of songs[i].data.zhida.zhida_singer.hotsong){
            hotSongListValue.push(
              {
                songMid: hotSong.songMID
                ,songName: hotSong.songName
              }
            )
          }
          singerData.nameList.push(songs[i].data.zhida.zhida_singer.singerName)
          singerData.songList.push(songListValue)
          singerData.hotSongList.push(hotSongListValue)
        }
      }
      else {
        if(songs[i].data.zhida.list.length === 0 ||
          typeof songs[i].data.zhida.list[0].zhida_singer === 'undefined')
        {
          let songListValue = []
          for(const list of songs[i].data.song.list){
            songListValue.push(
              {
                songName: list.name
                ,songMid: list.mid
                ,singer: list.singer
                ,mvMid: list.mv.vid
              }
            )
          }
          songData.nameList.push(songs[i].data.song.list[0].name)
          songData.songList.push(songListValue)
        }
        // 关键字是歌手
        else{
          let songListValue = []
          let hotSongListValue = []
          for(const list of songs[i].data.song.list){
            songListValue.push(
              {
                songName: list.name
                ,songMid: list.mid
                ,singer: list.singer
                ,mvMid: list.mv.vid
              }
            )
          }
          for(const hotSong of songs[i].data.zhida.list[0].zhida_singer.hotsong){
            hotSongListValue.push(
              {
                songMid: hotSong.songMID
                ,songName: hotSong.songName
              }
            )
          }
          singerData.nameList.push(songs[i].data.zhida.list[0].zhida_singer.singerName)
          singerData.songList.push(songListValue)
          singerData.hotSongList.push(hotSongListValue)
        }
      }


      }//把关键字按歌手和歌曲分类的for循环结束
      // 当关键字全为歌手时
      if(songData.nameList.length === 0 && songData.songList.length === 0){
        for(const value of singerData.hotSongList){
          for(const song of value){
            effect.keys += song.songMid + ","
          }
        }
      }
      // 当关键字全为歌曲时
      else if(singerData.nameList.length === 0 && singerData.songList.length === 0){
        for(const value of songData.songList){
          effect.keys += value[0].songMid + ","
        }
      }
      else{
        let keyList = []
        let restSongCount = songData.songList.length
        //首先把所有歌手作为整体，匹配所有歌曲
        //遍历输入的歌曲关键字
        let firstSongListCount = 0
        for(const value of songData.songList)
        {
          // 遍历每个歌曲关键字中的歌曲列表
          for(const song of value){
            // 如果歌手长度和歌曲列表歌手长度不匹配，不进行后续复杂操作
            if(song.singer.length !== singerData.nameList.length)
              continue
            let matching = []
            // 遍历歌曲中的歌手列表
            for(const singer of song.singer){
              // 遍历singerList中的歌手列表
              for(let i=0; i<singerData.nameList.length; i++){
                // 如果匹配，则对位数标记
                if(singer.name === singerData.nameList[i] && !matching[i])
                {
                  matching[i] = true
                }
              }
            }
            // 如果二者能完全匹配，则验证通过
            if(matching.filter((data)=>data === true).length === song.singer.length){
              keyList[firstSongListCount] = song.songMid
              songData.songList[firstSongListCount] = false
              songData.nameList[firstSongListCount] = false
              restSongCount--
              break
            }
          }
          firstSongListCount++
        }//歌手作为整体匹配结束
        // 歌手作为分割元素，分别匹配歌曲列表
        // 当songData.songList的length不为0，则说明需要继续匹配
        if(restSongCount > 0){
          let secondSongListCount = 0
          for(const value of songData.songList)
          {
            if(value === false){
              secondSongListCount++
              continue
            }
            for(const song of value){
              if(keyList[secondSongListCount]){
                break
              }
              for(let i=0; i<singerData.nameList.length; i++)
              {
                if(keyList[secondSongListCount]){
                  break
                }
                for(const singer of song.singer){
                  if(singer.name === singerData.nameList[i]){
                    keyList[secondSongListCount] = song.songMid
                    songData.nameList[secondSongListCount] = false
                    songData.songList[secondSongListCount] = false
                    restSongCount--
                    break
                  }
                }
              }
            }
            secondSongListCount++
          }
        }//歌手作为分割元素匹配结束
        // 开始歌曲作为分割元素匹配歌手的歌曲列表
        if(restSongCount > 0){
          let thirdSongListCount = 0
          for(const name of songData.nameList)
          {
            if(name === false){
              thirdSongListCount++
              continue
            }
            for(const list of singerData.songList)
            {
              if(keyList[thirdSongListCount]){
                break
              }
              for(const song of list){
                if(name === song.songName){
                  keyList[thirdSongListCount] = song.songMid
                  songData.nameList[thirdSongListCount] = false
                  songData.songList[thirdSongListCount] = false
                  restSongCount--
                  break
                }
              }
            }
            thirdSongListCount++
          }
        }//固定歌曲匹配歌手的歌曲列表结束
        // 开始剩余歌曲处理
        if(restSongCount > 0){
          let fourthSongListCount = 0
          for(const value of songData.songList){
            if(value === false){
              fourthSongListCount++
              continue
            }
            keyList[fourthSongListCount] = value[0].songMid
            songData.nameList[fourthSongListCount] = false
            songData.songList[fourthSongListCount] = false
            restSongCount--
            fourthSongListCount++
          }
        }//剩余歌曲处理结束
        //提取keyList的元素
        for(const key of keyList){
          effect.keys += key + ","
        }
      }
      // 组装播放url
      if(effect.keys !== "")
      {
        effect.keys += sessionStorage.getItem(Const.inputKey.playQQMusic) ?
        sessionStorage.getItem(Const.inputKey.playQQMusic) : ""
        effect.url = Const.httpApi.get(Const.inputKey.playQQMusic).playFirstHalf+
        effect.keys+Const.httpApi.get(Const.inputKey.playQQMusic).playSecondHalf
      }

    }//处理qq音乐effect的函数尾巴
  }
  handleKeyAndStorageWithSession = (value, keyName, count=Const.count.storageSongCount, isRepeat=true)=>{
    const lastValue = sessionStorage.getItem(keyName)
    let newStorage = ""
    let valueArray = lastValue ? (lastValue+value).trim().split(",") : value.trim().split(",")
    for(let i=0; i<valueArray.length; i++){
      if(valueArray[i] === ""){
        valueArray.splice(i,1)
      }
    }
    while (valueArray.length > count) {
      valueArray.shift()
    }
    if(!isRepeat){
      valueArray.sort()
      newStorage = valueArray[0]+","
      for(let i=1; i<valueArray.length; i++){
        if(valueArray[i] !== valueArray[i-1]){
          newStorage += valueArray[i]+","
        }
      }
    }
    else{
      for(let i=0; i<valueArray.length; i++){
        newStorage += valueArray[i]+","
      }
    }
    console.log(newStorage)
    sessionStorage.setItem(keyName, newStorage)
  }
  handleKeyAndStorageWithLocal = (value, keyName, count=Const.conut.storageSongCount, isRepeat=true)=>{
    const lastValue = localStorage.getItem(keyName)
    let newStorage = ""
    let valueArray = lastValue ? (lastValue+value).trim().split(",") : value.trim().split(",")
    for(let i=0; i<valueArray.length; i++){
      if(valueArray[i] === ""){
        valueArray.splice(i,1)
      }
    }
    while (valueArray.length > count) {
      valueArray.shift()
    }
    if(!isRepeat){
      valueArray.sort()
      newStorage = valueArray[0]
      for(let i=1; i<valueArray.length; i++){
        if(valueArray[i] !== valueArray[i-1]){
          newStorage += valueArray[i]+","
        }
      }
    }
    else{
      for(let i=0; i<valueArray.length; i++){
        newStorage += valueArray[i]+","
      }
    }
    localStorage.setItem(keyName, newStorage)
  }
  csvToArrayNoEmpty = (csv)=>{
    let valueArray = csv ? csv.trim().split(",") : []
    for(let i=0; i<valueArray.length; i++){
      if(valueArray[i] === ""){
        valueArray.splice(i,1)
      }
    }
    return valueArray
  }
}
export default DataTools



// WEBPACK FOOTER //
// ./src/toolsClass/DataTools.js